module.exports = __webpack_public_path__ + "img/paper_airplane_w.12fdcb8e.svg";